import api from './api';

export default class AvaliadorService {
  constructor() {
    throw 'Não é possível instanciar AvaliadorService';
  }

  static async lista(id, idMes) {
    const endpoint = mergeEndpoint(id, idMes);
    return await api.get(endpoint);
  }
}

const mergeEndpoint = (id, idMes) => {
  return `avaliacoes-periodicas/avaliadores/${id}/competencias/${idMes}/totais`;
};



// WEBPACK FOOTER //
// ./src/services/avaliadorService.js